<template>
    <div class="depot">
        <headerNotice routerName="折扣列表"></headerNotice>
        <!-- 搜索框 -->
        <div class="seach-box">
            <h2 class="title">
                <i></i>
                <span>筛选查询</span>
            </h2>
            <div class="input-wrapper">
                <el-row :gutter="24">
                    <!-- 輸入框 -->
                    <el-col :span="6" :offset="0">
                        <div>
                            <span>促销名称：</span>
                            <el-input
                                class="el-search"
                                v-model="promotionName"
                                placeholder=""
                            ></el-input>
                        </div>
                    </el-col>
                    <!-- 状态选择 -->
                    <el-col :span="7" :offset="0">
                        <div class="status">
                            <span>状态：</span>
                            <el-select v-model="stateValue" @change="selectGet" placeholder="全部">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <!-- 日期选择 -->
                    <el-col :span="9" :offset="0">
                        <div class="status">
                            <el-date-picker
                                v-model="dateValue"
                                type="datetimerange"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions2"
                            ></el-date-picker>
                        </div>
                    </el-col>
                    <!-- 查询按钮 -->
                    <el-col :span="1" :offset="0">
                        <div class="status">
                            <el-button type="primary" @click="searchConfirm">查询</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 促销限时折扣列表 -->
        <div class="depot-list">
            <div class="head">
                <h2 class="title">
                    <i></i>
                    <span>促销列表</span>
                </h2>
                <div class="control">
                    <el-button class="tip-box" @click="addDiscount">添加</el-button>
                </div>
            </div>
            <!-- 促销限时折扣列表 -->
            <div class="dataTable" v-loading="loading">
                <el-table
                    ref="singleTable"
                    :data="subtractionList"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    :default-sort="{prop: 'date', order: 'descending'}"
                >
                    <el-table-column property="title" prop="title" label="促销名称"></el-table-column>
                    <el-table-column property="startTime" prop="startTime" label="开始时间"></el-table-column>
                    <el-table-column property="dateEnd" prop="endTime" label="结束时间"></el-table-column>
                    <el-table-column property="status" prop="status" label="状态"></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                @click="editDiscount(scope.row)"
                            >编辑</el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="prohibitSales(scope.row)"
                                :disabled="scope.row.status == '已过期'"
                            >使失效</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--分页-->
        <div class="pagination-wrapper">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                center
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
const cityOptions = ["上海", "北京", "广州", "深圳"];
export default {
    components: {
        headerNotice
    },
    props: {},
    data() {
        return {
            state: true,
            readonly: false, // 编辑时部分数据设置只读
            index: 0,
            dialogLoading: true,
            loading: true,
            totalCount: 0,
            currentPage: 1,
            input: "",
            maxResultCount: 10, //默认一页显示的个数,
            subtractionList: [], //促销满减列表列表主数据
            promotionName: "", //满减名称
            stateValue: "", //满减状态
            stateVal: 0, //满减状态值
            dateValue: "", //满减时间
            formData: {
                title: "",
                reach: 0,
                abate: 0,
                startTime: "",
                endTime: "",
                customerScope: 1,
                cityScope: 1,
                itemPropScope: 1,
                content: "",
                itemPropIds: [],
                cityCodes: []
            },
            reginData: [], //区域数据
            defaultProps: {
                children: "children",
                label: "name"
            },
            checkedReginData: [], //屏蔽区域已选数据
            defaultKeys: [],
            areaNumber: 0, // 选中地区数量
            goodsNum: 0, // 选中商品数量
            goodsList: [], // 商品列表
            choosedItem: [], //已选择的商品列表
            goodsForm: {},
            showAddBox: false, //是否展示添加弹出框
            showArea: false, // 是否展示地区列表弹出框
            showGoods: false, // 是否展示商品列表弹出框
            reductionID: 0, // 点击详情时获取index
            itemPropIds: [], // 点击详情时获取选中商品
            chooseCustomerData: [], //所有选中的客户数据
            currentPageCustomer: [], //当前页选中的客户数据
            customerTotalCount: 0,
            options: [
                {
                    value: "0",
                    label: "全部"
                },
                {
                    value: "1",
                    label: "未开始"
                },
                {
                    value: "2",
                    label: "促销中"
                },
                {
                    value: "3",
                    label: "已过期"
                }
            ],
            pickerOptions2: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            checkAll: false,
            cities: cityOptions,
            multipleSelection: []
        };
    },
    watch: {},
    computed: {},
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
            Status: 0
        });
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSale/GetList",
                params: params,
                success(res) {
                    for (var i = 0; i < res.items.length; i++) {
                        if (res.items[i].status == 1) {
                            res.items[i].status = "未开始";
                        } else if (res.items[i].status == 2) {
                            res.items[i].status = "促销中";
                        } else if (res.items[i].status == 3) {
                            res.items[i].status = "已过期";
                        }
                    }
                    self.subtractionList = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            });
        },
        // 下拉框value值获取
        selectGet(vId) {
            this.stateVal = vId;
        },
        //名称 状态 日期条件查询
        searchConfirm() {
            if(this.dateValue) {
                this.getDatas({
                    MaxResultCount: this.maxResultCount,
                    Title: this.promotionName, //商品名称
                    Status: this.stateVal, //商品状态
                    StartTime: this.dateValue[0], //商品开始时间
                    EndTime: this.dateValue[1] //商品结束时间
                });
            }else{
                this.getDatas({
                    MaxResultCount: this.maxResultCount,
                    Title: this.promotionName, //商品名称
                    Status: this.stateVal, //商品状态
                    StartTime: null, //商品开始时间
                    EndTime: null //商品结束时间
                });
            }
            this.currentPage = 1
        },
        // 添加促销限时折扣
        addDiscount() {
            this.$router.push({'path': '/addDiscount'});
        },
        // 编辑促销限时折扣
        editDiscount(row) {
            this.$router.push({'path': '/editDiscount',query:{ saleID:row.saleID}});
        },
        //  禁用促销限时折扣
        prohibitSales(row) {
            let self = this;
            self.dialogLoading = true;
            let params = {
                saleID: row.saleID
            };
            this.$confirm("此操作将让促销失效, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    $http.POST({
                        url:
                            this.$store.state.apiUrl +
                            "/api/services/app/AdminSale/Cancel",
                        params: params,
                        success(res) {
                            self.$message({
                                message: "促销已失效",
                                type: "success"
                            });
                            self.getDatas({
                                MaxResultCount: this.maxResultCount,
                                Status: 0
                            });
                            self.currentPage = 1
                        },
                        fail(res) {
                            self.dialogLoading = false;
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消"
                    });
                });
        },
        handleSelectionChange(val) {
            this.choosedItem = val;
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: this.maxResultCount
            };
            this.getDatas(params);
        }
    },
    created() {}
};
</script>
<style lang="scss" scoped>
.depot {
    // 搜索
    .seach-box {
        border: 1px solid rgba(228, 228, 228, 1);
        margin: 20px 50px;
        .title {
            display: flex;
            align-items: center;
            height: 50px;
            font-weight: 400;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding-left: 20px;
            // i:first-child {
            //   width: 18px;
            //   height: 18px;
            //   background: green;
            // }
        }
        .input-wrapper {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 40px;
            .el-search {
                width: 180px;
            }
            .status {
                margin-left: 40px;
            }
        }
    }

    // 仓库列表
    .depot-list {
        margin: 0 50px;
        border: 1px solid rgba(228, 228, 228, 1);
        font-weight: 400;
        .head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            .title {
                display: flex;
                align-items: center;
                height: 50px;
                font-weight: 400;
                padding-left: 20px;
                // i:first-child {
                //   width: 18px;
                //   height: 18px;
                //   background: green;
                // }
            }
        }
        .control {
            .tip-box {
                width: 80px;
                padding-left: 0;
                padding-right: 0;
                margin-right: 20px;
            }
            .select-box {
                width: 100px;
                margin-left: 20px;
            }
        }
        // 弹出框
        .add-box {
            // width: 600px;
            /deep/ .el-dialog__header {
                display: flex;
                align-items: center;
                padding-top: 14px;
                background: rgba(242, 242, 242, 1);
                font-weight: 700;
            }
            .from-el {
                width: 600px;
            }
            .input-el {
                width: 420px;
            }
        }
    }
    // 分页
    .pagination-wrapper {
        text-align: center;
        margin-top: 20px;
    }
    // 文本框
    .el-textarea {
        width: 80%;
    }
}
</style>